import { useQueryWithProfile } from '@tv2/lib-offspring/api/graphql/useQueryWithProfile';
import { ActiveExperimentsDocument } from './__generated__/ActiveExperiments';
import { ActiveExperiment } from '../../__generated__/api/types';

export function useActiveExperiments(): { experiments: ActiveExperiment[]; fetching: boolean } {
  const { data, fetching } = useQueryWithProfile({
    query: ActiveExperimentsDocument,
    requestPolicy: 'network-only',
  });

  return { experiments: data?.activeExperiments ?? [], fetching };
}
